module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-executive-dashboard__chart trend-charts"
  }, [(_vm.loadingContent) ? _c('div', {
    staticClass: "a-loader--chart u-full-width"
  }) : _vm._e(), _vm._v(" "), (!_vm.loadingContent && !_vm.hasResults) ? _c('div', {
    staticClass: "p-executive-dashboard__chart__no-results"
  }, [_c('p', [_vm._v("Your search returned no results.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "trend-charts__line"
  }, [(!_vm.loadingContent && _vm.hasResults) ? _c('line-chart', {
    attrs: {
      "chart-data": _vm.lineChartData,
      "options": _vm.lineChartOptions,
      "width": 900
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "trend-charts__legend u-full-width"
  }, [(_vm.showing !== 'total' && _vm.diseaseTypeSelected || !_vm.diseaseTypeSelected) ? _c('chart-legend', {
    attrs: {
      "columns": 3,
      "values": _vm.lineChartLabels,
      "legendWidth": _vm.chartLegendWidth,
      "marginTop": "60"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin"
  }, [_c('div', {
    staticClass: "u-margin-top-20"
  }, [_c('option-filters', [_c('li', {
    class: {
      'm-option-filters--active': _vm.period === 'month'
    },
    on: {
      "click": function($event) {
        return _vm.updateTrendsInReservesPeriod('month')
      }
    }
  }, [_vm._v("\n                        Month\n                    ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.period === 'quarter'
    },
    on: {
      "click": function($event) {
        return _vm.updateTrendsInReservesPeriod('quarter')
      }
    }
  }, [_vm._v("\n                        Quarter\n                    ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.period === 'year'
    },
    on: {
      "click": function($event) {
        return _vm.updateTrendsInReservesPeriod('year')
      }
    }
  }, [_vm._v("\n                        Year\n                    ")])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14ccaa65!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/executive-dashboard/components/charts/TrendsChart.vue
// module id = 1579
// module chunks = 0